import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StateService } from '../services/state.service';

@Injectable({
  providedIn: 'root',
})
export class RoadSelectedGuard implements CanActivate {
  constructor(private stateService: StateService, private router: Router) {}

  canActivate(): boolean {
    const selectedRoad = this.stateService.getCurrentSelectedRoad();
    if (selectedRoad) {
      return true;
    } else {
      this.router.navigate(['/']); // Redirigir a la pantalla principal
      return false;
    }
  }
}
